import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    futureRepaymentTitle: {
        id: '_.rbl_dashboard.outstanding.futureRepaymentTitle',
        defaultMessage: 'Next repayment'
    },
    futureRepayment: {
        id: '_.rbl_dashboard.outstanding.futureRepayment',
        defaultMessage:
            'Your next repayment will be taken in {timeToRepayment} days'
    },
    overdueRepaymentTitle: {
        id: '_.rbl_dashboard.outstanding.overdueRepaymentTitle',
        defaultMessage: 'Get back on track'
    },
    overdueRepaymentDescription: {
        id: '_.rbl_dashboard.outstanding.overdueRepaymentDescription',
        defaultMessage: "We weren't able to take your monthly repayment."
    },
    overdueRepaymentCTA: {
        id: '_.rbl_dashboard.outstanding.overdueRepaymentCTA',
        defaultMessage: 'Get in touch'
    },
    reapplyTitle: {
        id: '_.rbl_dashboard.loanEnded.reapplyCTA',
        defaultMessage: 'Eligible for top up'
    },
    reapplyDescription: {
        id: '_.rbl_dashboard.loanEnded.reapplyDescription',
        defaultMessage:
            'You can now request a top up - approval is subject to credit review'
    },
    createReapplyRequest: {
        id: '_.rbl_dashboard.loanEnded.createReapplyRequest',
        defaultMessage: 'Request top up'
    },
    amountToRepayBeforeTopupEligible: {
        id: '_.rbl_dashboard.outstanding.amountToRepayBeforeTopupEligible',
        defaultMessage:
            'You’ll become eligible to request a top up once you’ve repaid {amountToRepayBeforeTopUp} – approval is subject to credit review'
    },
    topupApprovedTitle: {
        id: '_.rbl_dashboard.outstanding.topupApprovedTitle',
        defaultMessage: 'Top up approved'
    },
    topupApprovedDescription: {
        id: '_.rbl_dashboard.outstanding.topupApprovedDescription',
        defaultMessage:
            "We've approved your business for a top up! You've got another {amount} to take before {expiryDate}"
    },
    topupPendingTitle: {
        id: '_.rbl_dashboard.outstanding.topupPendingTitle',
        defaultMessage: 'Top up requested'
    },
    topupPendingDescription: {
        id: '_.rbl_dashboard.outstanding.topupPendingDescription',
        defaultMessage:
            'Thanks for your application for a top up to a credit limit of {amount}'
    },
    changeTopupRequest: {
        id: '_.rbl_dashboard.outstanding.changeTopupRequest',
        defaultMessage: 'Change request'
    },
    chooseDrawdownAmount: {
        id: '_.rbl_dashboard.outstanding.chooseDrawdownAmount',
        defaultMessage: 'Choose how much'
    }
});
